export const ADDRESSING_RULES_TYPES = {
  CD_PRIORITY: 'CD_PRIORITY',
  CD_PROXIMITY: 'CD_PROXIMITY',
  MATERIALIZE: 'MATERIALIZE',
  APP: 'APP',
} as const;

export const TIEBREAKER_RULES_TYPES = ['CD_PRIORITY', 'CD_PROXIMITY'];

export type AddressingRuleType =
  typeof ADDRESSING_RULES_TYPES[keyof typeof ADDRESSING_RULES_TYPES];
export type AddressingRuleGroupType = 'tiebreaker' | 'app' | 'materialize';

export const ADDRESSING_RULES_TRANSLATE_TYPES = {
  CD_PRIORITY: 'cdPriority',
  CD_PROXIMITY: 'cdProximity',
  APP: 'app',
  MATERIALIZE: 'materialize',
} as const;
